<template>
  <div id="exploration-point">
    <router-link v-if="presentationMode != true" :to="{ name: 'Exploration', params: {id: exploration.id, mode: 'list'} }" class="btn btn-outline-primary btn-sm map-back-button"><i class="fal fa-arrow-left"></i> {{ exploration.title }}</router-link>
    <div v-if="point.embedCode" class="point-content" v-html="point.embedCode">
    </div>
    <div v-else class="no-point">
      <i class="fal fa-binoculars"></i>
    </div>
  </div><!-- /#point-view -->
</template>

<script>
export default {
  props: ['exploration', 'point', 'presentationMode']
}
</script>



// WEBPACK FOOTER //
// src/components/ExplorationPoint.vue